import React from 'react';
import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg';
import { ReactComponent as NotCheckIcon } from '../../assets/icons/not-check.svg';
import classes from './index.module.scss';

const FrameThree = ({ onSubmit, inputValue, selectValue }) => {
  console.log(selectValue.filter(item => item.type === "naics") && selectValue.length)
  console.log()

  const checkSelectedValue = (selectValue, valueType) => {
    const existingSelectValue = selectValue.filter(item => item.type === valueType)

    return existingSelectValue.length
  }

  return (
    <div className={classes.Frame_Three}>
      <h3 className="mb-5">
        Please read for better understanding of matching to contracts
      </h3>
      <p className="mb-5">
        Your current matching criteria: 
      </p>
      <ul className={classes.Registration_Check_List}>
        <li>
          <p>Keywords</p>
          {inputValue.keywords ? <CheckIcon /> : <NotCheckIcon />}
        </li>
        <li>
          <p>NAICS</p>
          {checkSelectedValue(selectValue, 'naics') ? <CheckIcon /> : <NotCheckIcon />}
        </li>
        <li>
          <p>PSC</p>
          {checkSelectedValue(selectValue, 'psc_code') ? <CheckIcon /> : <NotCheckIcon />}
        </li>
        <li>
          <p>State(s)</p>
          <CheckIcon />
        </li>
      </ul>
      <p>
        NAICS CODES<br />
        NAICS codes are extremely important, <span>matches are generated using NAICS or PSC codes</span>. If you are utilizing ONLY PSC matching then feel 
        free to leave this field blank, if not then please include at least one NAICS code.
      </p>
      <p>
        PSC CODES<br />
        PSC codes are extremely important, <span>matches are generated using PSC or NAICS codes</span>. If you are utilizing ONLY NAICS matching 
        then feel free to leave this field blank, if not then please include at least one PSC code.
      </p>
      <p>
        KEYWORDS<br />
        Micro purchase opportunities are matched based on keywords.
      </p>
      <p>
        Micro purchase opportunities are posted to your dashboard based on your matching keywords. For example, if you are a web designer you 
        would want to put keywords such as web design, computer graphics, web development, website maintenance, etc. <span>The more specific the keywords, 
        the better the matches will be.</span> If you simply put the keyword 'design', you will get more matches that deal with design rather than web design 
        such as building designs, clothing designs, and so on.
      </p>
      <p>
        <span>Also, be sure to separate keywords with commas.</span> Matching is based on keywords/phrases. If you do not use a comma it will consider 
        it as a phrase until it has reached a comma. For example, if you put (web design, web maintenance, web development computer graphics) 
        it will consider 'web development computer graphics' as a phrase and only match three keywords/phrases. Choose your keywords carefully 
        by making them closely related to your business
      </p>
      <button 
        type="submit"
        className="filledBtn btnSizes"
        onClick={event => onSubmit()}
      >
        Save & Continue
      </button>
    </div>
  )
}

export default FrameThree;